<div class="otp-wrapper">
  <img  class="mb-2" src="../../../../assets/images/sms-code-verification.png" alt="sms-code-verification" loading="lazy">
  <!-- Header -->
  <div class="component-header text-center">
    <h3>{{ "Otp.ENTER_OTP" | translate }}</h3>
    <p class="mb-4" *ngIf="!hideDestination">
      {{ (signingFundId ? 'Otp.OtpWasSentToAuthorizedPersonPhoneNumber' : 'Otp.SENT_CODE') | translate }}
      <strong class="secondary_color">
        {{ phoneNumber | slice:-4 }}
      </strong>
    </p>
  </div>

  <!-- OTP Form -->
  <form autocomplete="off" [formGroup]="otpForm">
    <div class="d-flex align-items-center justify-content-around" dir="ltr">
      <!-- OTP Digit 1 -->
      <div class="col-2">
        <div class="otp_field">
        <input
            type="text"
            class="otp-input"
            id="otp1"
            maxlength="1"
            inputmode="numeric"
            pattern="[0-9]*"
            (input)="keytab1()"
            (keydown)="keyBackspace($event, 'otp1', null)"
            formControlName="otp1"
          />
        </div>
      </div>

      <!-- OTP Digit 2 -->
      <div class="col-2">
        <div class="otp_field">
        <input
          type="text"
          class="otp-input"
          id="otp2"
          maxlength="1"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="keytab2()"
          (keydown)="keyBackspace($event, 'otp2', 'otp1')"
          formControlName="otp2"
        />
        </div>
      </div>

      <!-- OTP Digit 3 -->
      <div class="col-2">
        <div class="otp_field">
        <input
          type="text"
          class="otp-input"
          id="otp3"
          maxlength="1"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)=" keytab3()"
          (keydown)="keyBackspace($event, 'otp3', 'otp2')"
          formControlName="otp3"
        />
        </div>
      </div>

      <!-- OTP Digit 4 -->
      <div class="col-2">
        <div class="otp_field">
        <input
            type="text"
            class="otp-input"
            id="otp4"
            maxlength="1"
            inputmode="numeric"
            pattern="[0-9]*"
            (input)="keytab4()"
            (keydown)="keyBackspace($event, 'otp4', 'otp3')"
            formControlName="otp4"
          />
        </div>
      </div>
    </div>

    <!-- Timer -->
    <div class="row align-items-center justify-content-center text-center mt-1">
      <p class="timer m-0 ">
        {{ "otpExpiresIn" | translate }}
      </p>
      <p class="m-0">
        {{ minutes }}:{{ seconds | number: "2.0" }}

      </p>
    </div>

    <!-- Verify Button -->
    <div class="text-center mt-3">
      <button
        type="button"
        class="main-btn w-100"
        (click)="verifyOTP()"
        [disabled]="!otpForm.valid || !(minutes > 0 || seconds > 0)"
      >
        {{ "Otp.VERIFY_OTP" | translate }}
      </button>
    </div>

        <!-- Resend OTP -->
    <div class="d-flex mt-3 mb-2 align-items-center">
      <span class="resend_otp m-auto"
          *ngIf="!(minutes > 0 || seconds > 0)"

      >
        {{ "Otp.NoT_GOT_CODE" | translate }}
        <button
          (click)="resendOtp()"
          class="btn resend-otp"
          type="button"
        >
          {{ "Otp.RESEND" | translate }}
        </button>
      </span>
    </div>
  </form>
</div>
